<template>

<div v-if="stored">
  Un mail vous a été envoyé
</div>
  <div v-else>
  <div>
    <label>L'adresse mail</label>
    <a-input v-model:value="user.email" :disabled="loading"></a-input>
  </div>

  <div style="text-align: right; margin-top: 10px">
    <a-button
      @click="lostPassword()"
      :loading="loading"
      type="primary"
      shape="round"
      ghost
    >
      Réinitialiser
    </a-button>
  </div>
  </div>
</template>


<script>
export default {
  name: "lostPassword",
  props: {
    errorData: {
      type: Object,
    },
  },
  data: () => {
    return {
      loading: false,
      stored: false,
      user: {
        email: "",
      },
    };
  },
  methods: {
    async lostPassword() {
      this.loading = true;
      this.errorData.show = false;

      await this.$axios
        .post("auth/forgot", this.user)
        .then((r) => {
          if (r.status === 201) {
            this.stored = true;
          }
        })
        .catch((e) => {
          this.errorData.message = e.response.data.message;
          this.errorData.is_courtier = e.response.data.is_courtier;
          this.errorData.show = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
